import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Maximize2 } from 'lucide-react';
import { Button } from '../ui/button';
import { categoriesData } from '../../data/companyData';

export const MachineSection = () => {
  // Get Machine & Facility and Measuring Instrument categories
  const facilityCategories = categoriesData.filter(cat => 
    ['machine-facility', 'measuring-instrument'].includes(cat.id)
  );

  return (
    <section 
      className="py-24 md:py-32 bg-gradient-to-br from-[#001582] to-[#000d5c]"
      data-testid="machine-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 bg-[#FFC107] rounded-full" />
            <span className="text-white text-sm font-semibold uppercase tracking-wider">Fasilitas</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Mesin & <span className="text-[#FFC107]">Fasilitas</span>
          </h2>
          <p className="text-slate-300 text-lg leading-relaxed">
            Advanced machining facilities dan workshop untuk mendukung proses manufacturing, 
            fabrication, dan repair dengan presisi tinggi.
          </p>
        </motion.div>

        {/* Gallery Grid - 2 column layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {facilityCategories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative overflow-hidden rounded-3xl"
            >
              <Link to={`/produk-layanan/${category.id}`}>
                <div className="aspect-[4/3] w-full">
                  <img 
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#001582] via-[#001582]/30 to-transparent" />
                  <div className="absolute inset-0 flex flex-col justify-end p-6">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-1 bg-[#FFC107] text-[#001582] text-xs font-bold rounded-full">
                        {category.items.length} Item
                      </span>
                    </div>
                    <h4 className="font-heading font-bold text-white text-xl md:text-2xl mb-2">{category.title}</h4>
                    <p className="text-slate-300 text-sm leading-relaxed line-clamp-2">{category.description}</p>
                    <span className="mt-4 inline-flex items-center text-[#FFC107] font-semibold text-sm">
                      Lihat Kategori
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </span>
                  </div>
                  <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Maximize2 className="w-5 h-5 text-white" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mt-12"
        >
          <Link to="/produk-layanan">
            <Button 
              size="lg"
              className="bg-[#FFC107] text-[#001582] hover:bg-[#FFD54F] font-semibold px-8 py-6 rounded-xl"
              data-testid="machine-cta"
            >
              Lihat Semua Produk & Layanan
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default MachineSection;
